import React from 'react';
import { Jumbotron, Row, Col, Container } from 'reactstrap';
import { faWater } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';


export const WisaSpinner: React.FC<{}> = () => {

  return (
    <Jumbotron className="mb-4">
      <Container className="p-4" fluid>
        <Row>
          <Col xl={12}  md={12} className="text-center">
            <FontAwesomeIcon icon={faWater} size="9x" />
            <p className="display-3"><FormattedMessage id="suspense_loading"/></p>
          </Col>
        </Row>
      </Container>
    </Jumbotron>
  );
}
